const assessmentTypes: Record<number, string> = {
	1: 'A for L',
	2: 'A of L',
	3: 'A as L',
	4: 'Non assessment',
	5: 'Academic Lesson',
};

export default assessmentTypes;
